import * as Yup from "yup";
import { regexPasswordValidation } from "./regexPasswordValidation";

export const personalDetailsSchema = Yup.object().shape({
  firstName: Yup.string().required("First name is required"),
  secondName: Yup.string().required("Second name is required"),
  email: Yup.string()
    .email("Must be a valid email")
    .required("Email is required"),
  userName: Yup.string().required("Username is required"),
  password: Yup.string()
    .required("Password is required")
    .min(8, "Password must be at least 8 characters long.")
    .max(50, "Password can be no more than 50 characters")
    .matches(
      regexPasswordValidation,
      "Password must contain at least one uppercase letter, one lowercase letter, one number and one special character."
    ),
  confirmPassword: Yup.string()
    .oneOf([Yup.ref("password"), undefined], "Passwords must match")
    .required("Confirm Password is required"),
});

const addressSchema = Yup.object().shape({
  firstLine: Yup.string().required("First line is required"),
  secondLine: Yup.string(),
  city: Yup.string().required("City is required"),
  state: Yup.string(),
  postCode: Yup.string(),
  countryId: Yup.string().required("Country is required"),
  phone: Yup.string(),
});

export const organisationDetailsSchema = Yup.object().shape({
  name: Yup.string().required("Organisation name is required"),
  billingEmail: Yup.string()
    .required("Billing email is required")
    .email("Must be a valid email"),
  address: addressSchema,
  currencyCode: Yup.string().required("Currency is required"),
  phone: Yup.string(),
  country: Yup.object(),
  vatNumber: Yup.string().max(20, "VAT number is too long"),
});

export const registerSchema = Yup.object().shape({
  personalDetails: personalDetailsSchema,
  organisationDetails: organisationDetailsSchema,
});
